import { injectCompanyToURL } from '@helpers'

import Api from '../api'
import {
  API_COMPANY_BANK_TRANSACTIONS_REPORT_URL,
  API_COMPANY_ONBOARDING_TASKS_URL,
  API_COMPANY_REPORT_URL,
  API_COMPANY_VAT_POSITION_REPORT_URL,
} from './urls'

export function fetchReports(companyId: number) {
  return Api.get(injectCompanyToURL(API_COMPANY_REPORT_URL, companyId))
}

export function fetchOnboardingTasks(companyId: number) {
  return Api.get(injectCompanyToURL(API_COMPANY_ONBOARDING_TASKS_URL, companyId))
}

export function fetchVatPositionReport(companyId: number) {
  return Api.get(injectCompanyToURL(API_COMPANY_VAT_POSITION_REPORT_URL, companyId))
}

export function fetchBankTransactionsReport(companyId: number) {
  return Api.get<BackendBankTransactionsReport>(injectCompanyToURL(API_COMPANY_BANK_TRANSACTIONS_REPORT_URL, companyId))
}
